import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Tabs, { Tab } from 'material-ui/Tabs';

const styles = theme => ({
  container: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  tab: {
    textTransform: 'capitalize',
    transition: "120ms all linear",
    fontWeight: 400,
    borderBottom: '2px solid #D8DBDF',
    '&:hover, &[aria-selected=true]': {
      borderBottom: '2px solid #1A65FF',
      fontWeight: 700,
      opacity: 1,
    }
  },
  spacer: {
    borderBottom: '2px solid #D8DBDF',
    width: '100%',
    maxWidth: "initial",
    opacity: "0.7 !important",
  },
  label: {
    color: '#181819',
    fontSize: '15px',
  },
  indicator: {
    backgroundColor: '#1A65FF',
    width: '100px',
  },
});

const FilterTabs = (props) => {
  const { classes, tabValues } = props;

  const handleChange = (e, value) => {
    props.handleTabClicked(value);
  };

  return (
    <div className={classes.container}>
      <Tabs
        value={props.value}
        onChange={handleChange}
        classes={{
          indicator: classes.indicator,
        }}
      >
        {tabValues.map((item, i) =>
        (<Tab
          className={classes.tab}
          classes={{ label: classes.label }}
          label={item.text}
          key={i}
          value={item.value}
        />))}
        <Tab className={classes.spacer} disabled={true} />
      </Tabs>
    </div>
  );
}


FilterTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  handleTabClicked: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  tabValues: PropTypes.array.isRequired, //an array of {text, value} objects
};

export default withStyles(styles)(FilterTabs);



// WEBPACK FOOTER //
// ./src/components/common/FilterTabs.jsx